// extracted by mini-css-extract-plugin
export default {"ReorderItem":"webpack-components-core-Reorder-Reorder-module__ReorderItem","DragHandle":"webpack-components-core-Reorder-Reorder-module__DragHandle"};